module.exports = __webpack_public_path__ + "img/benz.40503222.jpg";